import { render } from "./ExerciseTracker.vue?vue&type=template&id=38bc453b&scoped=true"
import script from "./ExerciseTracker.vue?vue&type=script&lang=js"
export * from "./ExerciseTracker.vue?vue&type=script&lang=js"

import "./ExerciseTracker.vue?vue&type=style&index=0&id=38bc453b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38bc453b"]])

export default __exports__